module.exports = __webpack_public_path__ + "static/img/summary-console.47551481.png";